import './Stakeholder.css';

function Stakeholders(){
    return(
        <div className='stk-background'>
            <label className='goal-value'>Our Goal Is To Create 360° Value</label><br></br>
            <label className='goal-value1'>For All Our Stakeholders</label><br></br>
            <button class="contect-us">CONTACT US</button>
        </div>
    )
}

export default Stakeholders;